import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=c3a9ef88&lang=scss"

const __exports__ = script;

export default __exports__